var _Circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle } from "react-native-svg";
function SvgNotificationBadge(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "badge",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "#fff",
    fill: "#18b8b8",
    "data-name": "Layer 1"
  })));
}
export default SvgNotificationBadge;